import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Hiring Manager & Secondary Contact Details\n          ")
], -1);
const _hoisted_4 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "block text-sm font-medium text-gray-700" }, "Hiring manager *", -1);
const _hoisted_6 = {
    key: 0,
    class: "col-span-6 mb-4"
};
const _hoisted_7 = {
    key: 0,
    class: "flex w-full justify-end"
};
const _hoisted_8 = { class: "col-span-6" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiringManagerName",
    class: "block text-sm font-medium text-gray-700"
}, "Hiring manager name: *", -1);
const _hoisted_10 = ["value"];
const _hoisted_11 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_12 = { class: "col-span-6 mt-4" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiringManagerEmail",
    class: "block text-sm font-medium text-gray-700"
}, "Hiring Manager email address: *", -1);
const _hoisted_14 = ["value"];
const _hoisted_15 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_16 = { class: "mt-4" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Would you like to add a secondary contact to this form? *\n            ", -1);
const _hoisted_18 = { class: "mt-4 space-y-4" };
const _hoisted_19 = { class: "flex items-start" };
const _hoisted_20 = { class: "h-5 flex items-center" };
const _hoisted_21 = ["checked", "disabled"];
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "yes",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1);
const _hoisted_23 = { class: "flex items-start" };
const _hoisted_24 = { class: "h-5 flex items-center" };
const _hoisted_25 = ["checked", "disabled"];
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "no",
        class: "font-medium text-gray-700"
    }, "No")
], -1);
const _hoisted_27 = {
    key: 0,
    class: "grid grid-cols-3 gap-6 sm:pt-5 mt-4"
};
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("p", { class: "text-md" }, "Secondary contact", -1);
const _hoisted_29 = {
    key: 0,
    class: "col-span-6 mb-4"
};
const _hoisted_30 = {
    key: 1,
    class: "col-span-6 p-4 border border-gray-300 rounded-md flex flex-col"
};
const _hoisted_31 = {
    key: 0,
    class: "flex w-full justify-end"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryName",
    class: "block text-sm font-medium text-gray-700"
}, "What is the employee name for your contact? *:", -1);
const _hoisted_33 = ["value"];
const _hoisted_34 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_35 = { class: "col-span-6 mt-4" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryEmail",
    class: "block text-sm font-medium text-gray-700"
}, "What is their email address? *:", -1);
const _hoisted_37 = ["value"];
const _hoisted_38 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_39 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_40 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_user_search = _resolveComponent("user-search");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("form", {
        onSubmit: _cache[17] || (_cache[17] =
            //@ts-ignore
            (...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(),
                        (!_ctx.hiring_manager)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(_component_user_search, {
                                    group: "HM",
                                    onUpdatedUser: _cache[0] || (_cache[0] = ($event) => (_ctx.handleUser($event, 'primary')))
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["col-span-6", { 'p-4 border border-gray-300 rounded-md': !_ctx.showApprovalSteps }])
                            }, [
                                (!_ctx.showApprovalSteps)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("button", {
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.handleClearUser('primary')), ["prevent"]))
                                        }, [
                                            _createVNode(_component_XIcon, { class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer" })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: "hiring-manager-name-input",
                                        value: _ctx.formData.hiringManagerName,
                                        type: "text",
                                        name: "hiringManagerName",
                                        autocomplete: "name",
                                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                        disabled: "",
                                        onInput: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.hiringManagerName.$touch()))
                                    }, null, 42, _hoisted_10),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.hiringManagerName.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "\n                * " + _toDisplayString(_ctx.v$.formData.hiringManagerName.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: "hiring-manager-email-input",
                                        value: _ctx.formData.hiringManagerEmail,
                                        type: "email",
                                        name: "hiringManagerEmail",
                                        autocomplete: "email",
                                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                        disabled: "",
                                        onInput: _cache[4] || (_cache[4] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.hiringManagerEmail.$touch()))
                                    }, null, 42, _hoisted_14),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.hiringManagerEmail.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "\n                * " + _toDisplayString(_ctx.v$.formData.hiringManagerEmail.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ], 2))
                    ]),
                    _createTextVNode(),
                    _createElementVNode("fieldset", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("input", {
                                        id: "radio-button-replacement-role",
                                        value: "yes",
                                        name: "secondary",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                        checked: _ctx.formData.secondary === 'yes',
                                        disabled: _ctx.showApprovalSteps,
                                        onBlur: _cache[6] || (_cache[6] = ($event) => (_ctx.v$.formData.secondary.$touch())),
                                        onChange: _cache[7] || (_cache[7] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, null, 42, _hoisted_21)
                                ]),
                                _createTextVNode(),
                                _hoisted_22
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("input", {
                                            id: "radio-button-candidates",
                                            value: "no",
                                            name: "secondary",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                            checked: _ctx.formData.secondary === 'no',
                                            disabled: _ctx.showApprovalSteps,
                                            onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.v$.formData.secondary.$touch())),
                                            onChange: _cache[9] || (_cache[9] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                        }, null, 42, _hoisted_25)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_26
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData.secondary === 'yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _hoisted_28,
                            _createTextVNode(),
                            (!_ctx.formData.secondaryName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createVNode(_component_user_search, {
                                        group: "HM",
                                        onUpdatedUser: _cache[10] || (_cache[10] = ($event) => (_ctx.handleUser($event, 'secondary')))
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    (!_ctx.showApprovalSteps)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createElementVNode("button", {
                                                onClick: _cache[11] || (_cache[11] = _withModifiers(($event) => (_ctx.handleClearUser('secondary')), ["prevent"]))
                                            }, [
                                                _createVNode(_component_XIcon, { class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer" })
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", null, [
                                        _hoisted_32,
                                        _createTextVNode(),
                                        _createElementVNode("input", {
                                            id: "secondary-name-input",
                                            value: _ctx.formData.secondaryName,
                                            type: "text",
                                            name: "secondaryName",
                                            autocomplete: "name",
                                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps }]),
                                            disabled: "",
                                            onInput: _cache[12] || (_cache[12] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.secondaryName.$touch()))
                                        }, null, 42, _hoisted_33),
                                        _createTextVNode(),
                                        (_ctx.v$.formData.secondaryName.$errors.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, "\n                * " + _toDisplayString(_ctx.v$.formData.secondaryName.$errors[0].$message), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_35, [
                                        _hoisted_36,
                                        _createTextVNode(),
                                        _createElementVNode("input", {
                                            id: "secondary-email-input",
                                            value: _ctx.formData.secondaryEmail,
                                            type: "email",
                                            name: "secondaryEmail",
                                            autocomplete: "email",
                                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: "",
                                            onInput: _cache[14] || (_cache[14] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.secondaryEmail.$touch()))
                                        }, null, 40, _hoisted_37),
                                        _createTextVNode(),
                                        (_ctx.v$.formData.secondaryEmail.$errors.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "\n                * " + _toDisplayString(_ctx.v$.formData.secondaryEmail.$errors[0].$message), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _createTextVNode(),
            (!_ctx.showApprovalSteps)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("button", {
                        class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        onClick: _cache[16] || (_cache[16] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                    }, "\n          Reset Form\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"
                    }, "\n          Next\n        ", 8, _hoisted_40)
                ]))
                : _createCommentVNode("", true)
        ])
    ], 32));
}
